module.exports = __webpack_public_path__ + "static/media/title.42a2f8e9.png";